import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { mercadoPagoReset } from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import { PortalContext } from "_+_Portal/context/Provider";
import { useContext } from "react";

const TiempoExtraLabo = () => {
  const { mercadoPagoDispatch } = useContext(PortalContext);
  const { pasoDispatch } = useContext(AutocheckContext);
  
  return (
    <ModalAutoT
      title={" ¿Requiere mas tiempo ?"}
      desc={
        "Si necesita mas tiempo para pagar correctamente por Mercado Pago oprima si"
      }
      textBtnOne={"SI"}
      textBtnTwo={"NO"}
      handleChange={{
        btnTwo: () => {
          mercadoPagoReset()(mercadoPagoDispatch);
          setPaso("AbonarMP")(pasoDispatch);
        },
        btnOne: () => {
          setPaso("AbonarMP")(pasoDispatch);
        },
      }}
    />
  );
};

export default TiempoExtraLabo;
